(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidoFazerController', PedidoFazerController);

        PedidoFazerController.$inject = ['Pedido', 'PedidoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'Propriedade', 'Safra', 'Mapaimagem', 'Maquinario', '$translate', 'Produto', 'PedidoProduto'];

    function PedidoFazerController(Pedido, PedidoSearch, ParseLinks, AlertService, paginationConstants, Propriedade, Safra, Mapaimagem, Maquinario, $translate, Produto, PedidoProduto) {

        var vm = this;

        vm.carregando = false;

        // Vetores auxiliares
        vm.ultimoIndice = null;

        vm.clickTeste = clickTeste;
        function clickTeste(){
            console.log(vm.mapasSelecionados);
        }

        // Preenchimento dos dados
        vm.filtroPropriedade = null;

        vm.propriedades = Propriedade.queryNomesPropriedades({
            size: 1000,
            sort: "nomepropriedade,asc"
        });

        vm.filtroSafra = null;

        vm.changeFiltroPropriedade = function () {
            
            vm.mapasSelecionados = [];
            vm.dadosMapas=[];

            
            vm.safras = vm.filtroPropriedade ?  Safra.querySafrasPorPropriedade({
                idPropriedade: vm.filtroPropriedade.id,
                size: 1000,
                sort: "nomesafra,asc"
            }) : [] ;   
            
        };

        vm.filtroTipoMapa = null;

        vm.maquinarios = Maquinario.query({
            size:1000,
            sort: "marca,asc"
        });

        // Filtros
        vm.atendeFiltros = atendeFiltros;

        function atendeFiltros(mapa){
            var atendeTodos = true;

            if(vm.filtroPropriedade != null) {
                if(vm.filtroPropriedade.id != mapa.propriedade_id){
                    return false;
                }
            }
            if(vm.filtroSafra != null) {
                if(vm.filtroSafra.id != mapa.safra_id){
                    return false;
                }
            }
            if(vm.filtroTipoMapa != null) {
                if(vm.filtroTipoMapa != mapa.tipomapa){
                    return false;
                }
            }

            if(mapa.tipomapa == 'nutricional'){
                return false;
            }

            if(vm.dataInicioIntervalo != null){
                var dataMapa = vm.ajustaData(mapa.data);
                var dataAntes = vm.somadia(vm.dataInicioIntervalo, -1);
                var dataDepois = vm.somadia(vm.dataInicioIntervalo, +1);
                console.log(dataMapa);
                console.log('>' + dataAntes);
                console.log('>>' + dataDepois);
                if(dataMapa < dataAntes || dataMapa > dataDepois){
                    return false;
                }
            }
            return true;
        }

        vm.aplicarFiltros = aplicarFiltros;

        function aplicarFiltros() {

            if(vm.filtroPropriedade == null){
                alert("Selecione uma propriedade!");
                return;
            }

            if(vm.dataInicioIntervalo == null || vm.dataInicioIntervalo == ""){
                alert("Selecione uma data!");
                return;
            }

            if(vm.filtroTipoMapa == ""){
                vm.filtroTipoMapa = null;
            }
            vm.dadosBaixados = Mapaimagem.querySemImagem({
                size: 3000,
                sort: "data,desc"
            }, vm.onCarregarMapasParaFiltros);
        }

        vm.onCarregarMapasParaFiltros = onCarregarMapasParaFiltros;

        function onCarregarMapasParaFiltros(data){
            vm.dadosMapas = [];

            for(var i = 0; i < data.length; i++){
                
                var estaNaLista = false;
                
                if(data[i].wktNull == true){
                    continue;
                }
                
                for(var j=0; j<vm.mapasSelecionados.length; j++){
                    if(vm.mapasSelecionados[j].id == data[i].id){ // Se o mapa já esta lá
                        estaNaLista = true;
                        break;
                    }
                }
                

                if(!estaNaLista && vm.atendeFiltros(data[i])){
                    vm.dadosMapas.push(data[i]);
                }
            }
            //vm.onCarregarDadosMapas(vm.dadosMapas);
        }

        // Controle do intervalo
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus.dataInicio = false;
        vm.datePickerOpenStatus.dataFim = false;
        vm.dateformat = "dd/MM/yyyy";


        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.dataInicioIntervalo = null;
        vm.dataFimIntervalo = null;

        vm.teste = function(){
            console.log(vm.dataInicioIntervalo);
        };

        // Mapas da Galeria
        vm.onCarregarDadosMapas = onCarregarDadosMapas;
        vm.dadosMapas = [];
        vm.imagensMapas = [];

        /*
        vm.dadosMapas = Mapaimagem.querySemImagem({
            size: 10,
            sort: "data,desc"
        }, vm.onCarregarDadosMapas);*/

        function onCarregarDadosMapas(data){
            //console.log(data);
            for(var i = 0; i < data.length; i++) {
                var element = data[i];
                var id = element.id;
            }
        }

        //Mapas Selecionados
        vm.mapasSelecionados = [];
        vm.removerMapaSelecionado = removerMapaSelecionado;

        function removerMapaSelecionado(mapa){
            var id = mapa.id;
            
            var vetorTemp = [];

            for (var index = 0; index < vm.mapasSelecionados.length; index++) {
                var element = vm.mapasSelecionados[index];
                if(element.id != id){
                    vetorTemp.push(element);
                }
            }

            vm.mapasSelecionados = vetorTemp;
        
            for(var i=0; i<vm.dadosMapas.length; i++){
                if(vm.dadosMapas[i].id == id){ // Se o mapa já esta lá
                    return;
                }
            }

            if(vm.atendeFiltros(mapa)){
                vm.dadosMapas.push(mapa);
            }
        }


        // Transição (click no mapa)
        vm.adicionarMapasSelecionados = adicionarMapasSelecionados;

        function adicionarMapasSelecionados(mapa){
            vm.carregando = true;
            // Trocar mapa de lista
            var id = mapa.id;
            
            for(var i=0; i<vm.mapasSelecionados.length; i++){
                if(vm.mapasSelecionados[i].id == id){ // Se o mapa já esta lá
                    return;
                }
            }

            var vetorTemp = [];

            for (var index = 0; index < vm.dadosMapas.length; index++) {
                var element = vm.dadosMapas[index];
                if(element.id != id){
                    vetorTemp.push(element);
                }
            }

            vm.dadosMapas = vetorTemp;

            vm.mapasSelecionados.push(mapa);

            vm.carregando = false;

        }

        // Auxiliares
        vm.ajustaData = ajustaData;
        function ajustaData(dataString){
            var d = new Date(dataString);
            d.setDate(d.getDate()+1);
            d.setHours(0);
            return d;        
        }

        vm.somadia = somadia;
        function somadia(d, valor){
            var n = new Date(d);
            n.setDate(n.getDate() + valor);
            n.setHours(0);
            return n;
        }

        //Confirmação de pedido
        vm.confirmarPedido = confirmarPedido;
        function confirmarPedido(){

            if(vm.vazao == null || vm.vazao==""){
                alert("Preencha a vazão");
                return;
            }

            if(vm.crea == null || vm.crea==""){
                alert("Preencha a CREA");
                return;
            }

            if(vm.nomeengenheiro == null || vm.nomeengenheiro==""){
                alert("Preencha a nome do Engenheiro");
                return;
            }

            if(vm.maquinario == null || vm.maquinario==""){
                alert("Preencha o maquinário correspondente");
                return;
            }
            for(var i=0; i<vm.produtosPedido.length; i++) {
                var elemento = vm.produtosPedido[i];
                if(elemento.produto == null || elemento.produto == ""){
                    alert("Preencha todos os produtos corretamente!");
                    return;
                }
                if(elemento.dose == null || elemento.dose == ""){
                    alert("Preencha a dose corretamente");
                    return;
                }

            }

            var pedido = new Pedido();

            var stringMapas = "";
            pedido.tipos = "";
            for(var i=0; i<vm.mapasSelecionados.length; i++){
                if(i==0){
                    stringMapas = vm.mapasSelecionados[i].id;
                    $translate('netWordAgroApp.Tipomapa.' + vm.mapasSelecionados[i].tipomapa).then(function(t){
                        pedido.tipos = t;
                    });
                }
                else{
                    stringMapas = stringMapas + ',' + vm.mapasSelecionados[i].id;
                    $translate('netWordAgroApp.Tipomapa.' + vm.mapasSelecionados[i].tipomapa).then(function(t){
                        pedido.tipos = pedido.tipos + ' - ' + t;
                    });
                }
            }

            pedido.idsmapas = stringMapas;
            pedido.vazao = vm.vazao.toString().replace(",", ".");
            pedido.maquinario = new Maquinario;
            pedido.maquinario.id = vm.maquinario.id;
            pedido.nomeengenheiro = vm.nomeengenheiro;
            pedido.propriedade = new Propriedade()
            pedido.propriedade.id = vm.mapasSelecionados[0].propriedade_id;
            pedido.safra = new Safra();
            pedido.safra.id = vm.mapasSelecionados[0].safra_id;
            pedido.status = "aguardando";
            pedido.crea = vm.crea;
            pedido.datas = vm.mapasSelecionados[0].data;            
            Pedido.save(pedido, vm.onPedidoSave);
        }

        vm.onPedidoSave = onPedidoSave;
        function onPedidoSave(result){
            var idPedido = result.id;

            for(var i=0; i<vm.produtosPedido.length; i++) {
                vm.produtosPedido[i].pedido = new Pedido();
                vm.produtosPedido[i].pedido.id = idPedido;
            }

            PedidoProduto.acao({acao: "create"}, vm.produtosPedido, vm.onSave); 
        };

        vm.onSave = onSave;
        function onSave(){
            $scope.$emit('netWordAgroApp:pedidoUpdate', result);
        }

        vm.adicionarProduto = adicionarProduto;
        vm.indiceVetor = 0;
        vm.produtos = [];
        vm.produtos[0] = Produto.query({
            sort: "nomecomercial,asc",
            size: 1000
        });

        vm.removerProduto = removerProduto;
        vm.moverProdutoBaixo = moverProdutoBaixo;
        vm.moverProdutoCima = moverProdutoCima;
        vm.produtosPedido = [];

        function adicionarProduto(){
            var ppNovo = new PedidoProduto();
            ppNovo.ordem = vm.indiceVetor + 1;
            vm.indiceVetor = vm.indiceVetor + 1;           
            vm.produtosPedido.push(ppNovo);
            vm.produtos[ppNovo.ordem] = vm.produtos[0];
            console.log(vm.produtosPedido);
        }

        function removerProduto(produto){
            var listaNova = [];
            var ordemRemocao = produto.ordem;

            for(var i=0; i<vm.produtosPedido.length; i++) {
                var elemento = vm.produtosPedido[i];
                if(elemento.ordem == ordemRemocao){
                    continue;
                }
                else if(elemento.ordem != ordemRemocao){
                    if(elemento.ordem > ordemRemocao){
                        elemento.ordem = elemento.ordem - 1;
                    }
                    listaNova.push(elemento);
                }
            }

            vm.produtosPedido = listaNova;
            vm.indiceVetor = vm.indiceVetor - 1;

        }

        function moverProdutoCima(produto){

            if(produto.ordem == 1){
                return;
            }

            var anterior = vm.produtosPedido[produto.ordem-2];
            var atual = vm.produtosPedido[produto.ordem-1];

            vm.produtosPedido[produto.ordem-2] = new PedidoProduto();
            vm.produtosPedido[produto.ordem-1] = new PedidoProduto();

            vm.produtosPedido[produto.ordem-2] = atual;
            vm.produtosPedido[produto.ordem-1] = anterior;

            atual.ordem = atual.ordem - 1;
            anterior.ordem = anterior.ordem + 1;


        }

        function moverProdutoBaixo(produto){

            if(produto.ordem == vm.produtosPedido.length){
                return;
            }

            var posterior = vm.produtosPedido[produto.ordem];
            var atual = vm.produtosPedido[produto.ordem-1];

            vm.produtosPedido[produto.ordem] = new PedidoProduto();
            vm.produtosPedido[produto.ordem-1] = new PedidoProduto();

            vm.produtosPedido[produto.ordem] = atual;
            vm.produtosPedido[produto.ordem-1] = posterior;

            atual.ordem = atual.ordem + 1;
            posterior.ordem = posterior.ordem - 1;

        }

        vm.changeFiltroTipo = function (tipo, ordem) {
            vm.produtos[ordem] = [];
            Produto.query({
                sort: "nomecomercial,asc",
                size: 1000
            }, function (result){
                for (var i=0; i<result.length;i++) {
                    if (result[i].tipo == tipo) {
                        vm.produtos[ordem].push(result[i]);
                    }
                }
            });
        }
    }
})();
